import { getAADApplication } from '@ms/yammer-telemetry';
import { getTenantIdFromToken, getUserIdFromToken } from '@ms/yammer-web-authenticators';

import { getEnvironment } from './ecsFilters';

export const getManagedApiRequestQuery = (token: string) => {
  const aadApplication = getAADApplication();
  const aadEnvironment = getEnvironment();
  const aadUserId = getUserIdFromToken(token);
  const aadTenantId = getTenantIdFromToken(token);

  return {
    Application: aadApplication,
    Environment: aadEnvironment,
    UserId: aadUserId,
    TenantId: aadTenantId,
  };
};

export interface EcsUserContext {
  readonly userId: string;
  readonly tenantId: string;
}

export const getEcsRequestQueryFromUserContext = (userContext: EcsUserContext) => {
  const aadApplication = getAADApplication();
  const aadEnvironment = getEnvironment();

  return {
    Application: aadApplication,
    Environment: aadEnvironment,
    UserId: userContext.userId,
    TenantId: userContext.tenantId,
  };
};
